import { put , call, takeEvery} from 'redux-saga/effects';
import {setApprovalList , setApiStatus, setSelectedTab} from '../actions/ApprovalListActions';
import ApprovalService from "../services/ApprovalService";


export function* approvalDetailsSaga(){

    yield takeEvery('GET_APPROVAL_DETAILS', function* (action){
        const { approvalId } = action;
        yield call(approvalDetailsActionSaga,approvalId);
    })  
}

export function* approvalDetailsActionSaga(approvalId){
    let list = [];
    yield put(setApprovalList(list));
    yield put(setApiStatus(true));
    try{
        const response = yield call(ApprovalService.getApprovalDetails, approvalId);
        yield put(setApiStatus(false));
        if (response.data) {
            //set selected tab ID, workflowID
            yield put(setSelectedTab(response.data.flowId));

            let approvalList = [];
            approvalList.push(response.data);
            //set approval List
            yield put(setApprovalList(approvalList));
        }
    }catch(error){
        yield put(setApiStatus(false));
        yield put(setApprovalList([]));
    }
    
}
